import React from 'react';
import { StyledSpinner } from './Spinner.styles';
import Lottie from 'lottie-react';
import logoAnimation from '../../assets/gifs/logo.json';

const Spinner = ({ src, width, height }) => {
  return (
    <StyledSpinner $width={width} $height={height}>
      <Lottie animationData={logoAnimation} loop />
    </StyledSpinner>
  );
};

export default Spinner;
